import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'


import authRoutes from '@/routers/auth'
import guestRoutes from '@/routers/guest'
import frontendRoutes from '@/routers/frontend'
import UIkit from "uikit";

Vue.use(VueRouter);
Vue.use(Loading);



let pageLoader
// @ is alias of src
let routes = [
  {
    path: '/',       // all the routes which can be access without authentication
    component: () => import('@layouts/GuestPage'),
    meta: { validate: ['is_guest'] },
    children: [
      ...guestRoutes,
    ]
  },
  {
    path: '/',
    component: () => import('@layouts/DefaultPage'),
    meta: { validate: ['is_auth'] },
    children: [
      ...authRoutes,
    ]
  },
  {
    path: '/',
    component: () => import('@layouts/DefaultHeader'),
    meta: { validate: ['is_frontend'] },
    children: [
      ...frontendRoutes,
    ]
  },

]


const router = new VueRouter({
  mode: 'history',
	routes,
	//linkActiveClass: 'active',

	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {x: 0, y: 0}
		}
	}
})

router.beforeEach((to, from, next) => {
	pageLoader = Vue.$loading.show();

  helper.setConfig().then(() => {
    let auth_token = Vue.cookie.get('auth_token');
    if(auth_token && !helper.getAuthStatus()) {
      pageLoader.hide();
      helper.clearSession();
      return next({ path: '/login' })
    }

    if (to.matched.some(m => m.meta.validate)){

      const m = to.matched.find(m => m.meta.validate);

      // Check for authentication; If no, redirect to "/login" route
      if ((m.meta.validate.indexOf('is_auth') > -1 || m.meta.validate.indexOf('is_frontend') > -1)  && !auth_token){
        helper.clearSession();
        UIkit.notification("Error", {status: 'Authentication required to perform this action'});
        pageLoader.hide();
        return next({ path: '/login' })
      }
      /*else if(m.meta.validate.indexOf('is_auth') > -1 && auth_token && !helper.hasPartnerApproved() && !helper.hasNewPartner()) {
        pageLoader.hide();
        helper.setNewPartner();
        return next({ path: '/partner-registration' })
      }*/
      // Check for authentication; If authenticated, redirect to "/dashboard" route
      else if (m.meta.validate.indexOf('is_guest') > -1 && auth_token){
        pageLoader.hide();
        return next({ path: '/dashboard' })
      }
    }
    return next()
  });


});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
	pageLoader.hide()
})

export default router



// WEBPACK FOOTER //
// ./src/routes.js